import {
    loadConversationId as loadConv,
    saveConversationId as saveConv,
    clearConversationId as clearConv,
  } from '../../utils/storage';
  import type { ChatMemoryScope } from '../../types';
  
  type Params = {
    scope?: ChatMemoryScope;
    agentId: string | null;
    resumeKeySuffix?: string;
  };
  
  export function useConversationPersistence({ scope, agentId, resumeKeySuffix }: Params) {
    const loadSavedConversationId = (): string | null => {
      if (!scope) return null;
      return loadConv(scope, agentId, resumeKeySuffix);
    };
  
    const saveConversationId = (conversationId: string): void => {
      if (!scope || !conversationId) return;
      saveConv(scope, agentId, conversationId, resumeKeySuffix);
    };
  
    const clearSavedConversationId = (): void => {
      if (!scope) return;
      clearConv(scope, agentId, resumeKeySuffix);
    };
  
    return { loadSavedConversationId, saveConversationId, clearSavedConversationId } as const;
  }
  